<template>
  <div id="app">
    <Notif />
    <navbar v-if="!$route.meta.headless"/>
    <router-view class="main_content"/>
  </div>
</template>
<script>
import navbar from './components/navbar';
import Notif from './components/notif';

export default {
  name: 'App',
  components: { navbar, Notif },
  data() {
    return {};
  },
  methods: {
    manageTitle() {
      document.title = `${this.$route.name} » Divine-World`;
    },
  },
  watch: {
    $route: 'manageTitle',
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
#app{
  position: relative;
  max-width: 1240px;
  margin: 0 auto;
  .main_content{
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue